import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModelliMansioni } from 'src/app/models/modelli-mansioni';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModelliMansioniService {
  private http = inject(HttpClient);
  modUrl = environment.ildatoArticoliDpi + 'api/modellimansioni';

  list(): Observable<ModelliMansioni[]> {
    return this.http.get<ModelliMansioni[]>(`${this.modUrl}`);
  }

  listByMansione(idMansione: number): Observable<ModelliMansioni[]> {
    return this.http.get<ModelliMansioni[]>(
      `${this.modUrl}/bymansione/${idMansione}`,
    );
  }

  get(id: number): Observable<ModelliMansioni> {
    return this.http.get<ModelliMansioni>(`${this.modUrl}/${id}`);
  }

  insert(values: ModelliMansioni): Observable<ModelliMansioni> {
    return this.http.post<ModelliMansioni>(`${this.modUrl}`, values);
  }

  update(id: number, values: ModelliMansioni): Observable<ModelliMansioni> {
    return this.http.put<ModelliMansioni>(`${this.modUrl}/${id}`, values);
  }

  remove(id: number): Observable<ModelliMansioni> {
    return this.http.delete<ModelliMansioni>(`${this.modUrl}/${id}`);
  }
}
